// extracted by mini-css-extract-plugin
export default {"specifications_heading":"Specifications_specifications_heading__jM6PH"};